import { configService } from '@/services/configService.js';
import { authTokenService } from '@/services/authTokenService.js';

export const utilityService = {
  getApiUrl: (urlFragment) => __getApiUrl(urlFragment),
  getBaseUrl: (urlFragment) => __getBaseUrl(urlFragment),
  convertStringToNum: (val) => _convertStringToNum(val),
  scrollElemIntoView: (id) => __scrollElementIntoView(id),
  getHeaders: () => __getHeaders(),
  addCurrencyCommas: (val) => __addCurrencyCommas(val),
	getDisplayLayouts: () => __getDisplayLayouts(),
	getSurveyTypes: () => __getSurveyTypes(),
	getOrganizationSections: () => __getOrganizationSections(),
	getTimeStamp: () => __getTimeStamp()
};

const regex = /,/gi;

function _convertStringToNum (val) {
  if (!val) return 0;

  if (typeof (val) === 'string') return parseInt(val.replace(regex, ''), 10);

  return val;
}

function __scrollElementIntoView (id) {
  if (id) {
      document.getElementById(id).scrollIntoView();
  }
}

/**
 * Appends the url fragment to the api url base.
 * @param {string} urlFragment - A url fragment to append to the api url base.
 */
function __getApiUrl (urlFragment) {
  debugger;
  return baseApiUrl + urlFragment.trim();
}

function __getBaseUrl (urlFragment) {
  return 'https://localhost:8080/' + urlFragment.trim();
}
debugger;
const baseApiUrl = configService.api_url;

/**
 * Gets the headers for a web service call. If a token is available it is added to the headers.
 */
function __getHeaders () {
  let headers = { 'Content-Type': 'application/json' };
  let token = authTokenService.getToken();

  if (token) {
      headers.Authorization = 'Bearer ' + token;
  }

  return headers;
}

function __addCurrencyCommas (val) {
  return val.replace(/\D/g, '')
	.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// These layouts are for helping choose the layout of the data based on answer objects/arrays as well as display options
// We refer to each question as a section
const displayLayouts = {
  // Fake subs layout, this layout has subsections but they are saved in seperate entries in an array of answers (array length >= 1).
  A: 1,
  // Sections with column totals (for sections and subsections, if any) and row totals, answer array has a single item (array length = 1).
  B: 2,
  // Sections with column totals (for sections and subsections, if any) and row totals, answer array has an entry per row of data (array length >= 1).
  C: 3,
  // Sections with column totals (for sections and subsections, if any) and row totals, answer array has a single item with sub-objects (array length = 1 and contains objects).
  D: 4,
  // Reference cells in input column and special computation cell (array length = 1).
  E: 5,
  // Section with radio buttons in each row (array length = 1).
  F: 6,
  // Section with special computation cells (array length = 1).
  G: 7,
  // Section with static and dynamic rows (array length >= 1).
  H: 8,
  // Section with dynamic rows and static total field only (array length >= 1).
  I: 9,
  // Section without totals (currently a single row section) (array length = 1).
  J: 10,
  // Sections with column totals (for sections and subsections, if any). Answer array has a single item (array length = 1). No row total.
  K: 11,
	M: 12,
	N: 13
}

// These are the types of survey currently supported
const surveyTypes = {
	Standard: 1,
	DOD: 2
}

// These are the survey types and respective sections for each organization type
const organizationSections = {
  Standard: {
		academic: "18",
    nonprofit: "19"
  },
  DOD: {
    academic: "19",
		nonprofit: "20",
    nonprofit: "21"
  }
}

/**
 * Gets all the options for displayLayouts
 */
function __getDisplayLayouts () {
	return displayLayouts;
}

/**
 * Gets all the options for survey types
 */
function __getSurveyTypes () {
  return surveyTypes;
}

/**
 * Gets the organization section id's (Store key) for all survey types
 */
function __getOrganizationSections () {
  return organizationSections;
}

/**
 * Gets a timestamp in a user readable format. Used for the last saved timestamp.
 */
function __getTimeStamp () {
	let currentDatetime = new Date();
	console.debug(currentDatetime.toString());
	let formattedDate =
		currentDatetime.getFullYear() +
		'-' +
		__appendLeadingZeroes(currentDatetime.getMonth() + 1) +
		'-' +
		__appendLeadingZeroes(currentDatetime.getDate()) +
		' ' +
		__appendLeadingZeroes(currentDatetime.getHours()) +
		':' +
		__appendLeadingZeroes(currentDatetime.getMinutes()) +
		':' +
		__appendLeadingZeroes(currentDatetime.getSeconds());
		return formattedDate;
}

/**
 * Appends leading zeroes to the number if it is a single digit.
 * @param {Number} n - The number to pad.
 */
function __appendLeadingZeroes (n) {
	if (n <= 9) {
		return '0' + n;
	}
	return n;
}
